// Internal
import { tokenService } from './token.service';
import { config } from '@/infrastructure';
import { FinderVenduto } from '@/models';

class DownloadService {
  async CSVReintegro(idReintegro: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/CSVreintegro/${idReintegro}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async CSVVenduto(finderVenduto: FinderVenduto): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(finderVenduto)
    };

    try {
      return await fetch(`${config.authUrl}/download/CSVvenduto/`, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async CSVDistintaDinamica(idDiba: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/csv-diba-dinamica/${idDiba}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async XLSXPackingListLavorazione(idLavorazione: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/xlsx-packing-list/${idLavorazione}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async XLSXPackingListLavorazioneSpacchettato(idLavorazione: string, idOrdine: string): Promise<Response | undefined> {
    const token = tokenService.getToken();
    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/xlsx-packing-list-spacchettato/${idLavorazione}/${idOrdine}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async XLSXPackingListOrdine(idOrdine: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/xlsx-packing-list-ordine/${idOrdine}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async CSVSpedizionePackingList(idSpedizione: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/csv-packing-list/${idSpedizione}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async CSVSpedizionePackingListExtended(idSpedizione: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
    };

    try {
      let url = `${config.authUrl}/download/csv-packing-list-extended/${idSpedizione}`;
      return await fetch(url, requestOptions);
    } catch (err) {
      throw(err);
    }
  }
  
  async downloadAllegato(id: string, fornitore: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
        }
    };
    var url = new URL(`${config.authUrl}/attachments/mtm`);
    url.searchParams.append('idAllegato',  id);
    url.searchParams.append('fornitore',  fornitore);
    console.log(url.toString())
    try {
      return await fetch(url.toString(), requestOptions);
    } catch (err) {
      throw(err);
    }
  }

  async downloadAllegatoOrdine(lam: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
        }
    };
    var url = new URL(`${config.authUrl}/attachments/production-order`);
    url.searchParams.append('lam',  lam);
    console.log(url.toString())
    try {
      return await fetch(url.toString(), requestOptions);
    } catch (err) {
      throw(err);
    }
  }
  async downloadSchedaTecnicaModello(templateScheda: string, modello: string, stagione: string): Promise<Response | undefined> {
    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
        }
    };
    var url = new URL(`${config.authUrl}/attachments/scheda-tecnica`);
    url.searchParams.append('templateScheda',  templateScheda );
    url.searchParams.append('modello',  modello);
    url.searchParams.append('stagione',  stagione);
    try {
      return await fetch(url.toString(), requestOptions);
    } catch (err) {
      throw(err);
    }
  }
}



export const downloadService = new DownloadService();